import { useSelector } from 'react-redux';
import { contributorsWithTeamIdsSelector } from 'state/selectors/contributors';
import { myAccountSelector } from 'state/selectors/account';
import { isViewer } from 'common/services/accounts.service';
import {
  Banner,
  DiagonalArrowIcon,
  FanfareDudeIllustrations
} from '@linearb/linui-common';
import { Box, Stack, Unstable_Grid2 as Grid } from '@mui/material';
import { Body1, Body2, H4 } from '@linearb/linui-common/typography';
import { Link } from 'react-router-dom';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';
import { isTeamLicenseSelector } from 'state/selectors/license';

function AllContributorsBanner() {
  const contributorsWithTeamIds = useSelector(contributorsWithTeamIdsSelector);
  const myAccount = useSelector(myAccountSelector);
  const isTeamLicense = useSelector(isTeamLicenseSelector);
  const teamsSettingsPath = isTeamLicense
    ? AppRouter.CONTRIBUTORS_SETTINGS.path
    : AppRouter.TEAMS_SETTINGS.path;

  const canAccessSettings = !isViewer(myAccount);
  const totalContributors = contributorsWithTeamIds.length;
  const totalContributorsInTeams = contributorsWithTeamIds.filter(
    (contributor: { teamIds: string | any[] }) => contributor.teamIds.length
  ).length;

  return (
    <Box width={'100%'} marginBottom={'1rem'}>
      <Banner>
        <Grid container>
          <Grid
            sm={2}
            sx={{ position: 'relative' }}
            display={{ xs: 'none', md: 'block' }}
          >
            <Box
              sx={{
                '>svg': {
                  position: 'absolute',
                  bottom: -54
                }
              }}
              width={167}
              height={80}
              paddingInlineEnd={1}
            >
              <FanfareDudeIllustrations />
            </Box>
          </Grid>

          <Grid sm={canAccessSettings ? 7 : 10} alignContent={'center'}>
            <Stack gap={0.5} justifyContent='space-around'>
              <H4>Unlock Your Data&apos;s Full Potential!</H4>

              <Body1>
                Maximize your insights by associating all your code contributors
                with their teams. Access comprehensive data and enhance your
                team&apos;s performance.
              </Body1>

              <Body2 bold>
                You’re viewing data from the last 90 days for all{' '}
                {totalContributors} Git contributors, including unpaid ones,
                with {totalContributorsInTeams} of them organized into teams.
              </Body2>
            </Stack>
          </Grid>

          {canAccessSettings && (
            <Grid
              sm={3}
              display='flex'
              justifyContent='end'
              alignItems='center'
            >
              <LBButton
                data-testid='GoToCompanySettingsBtn-test-id'
                size='lg'
                asChild
              >
                <Link to={`${teamsSettingsPath}?isOrgSettings=true`}>
                  <DiagonalArrowIcon /> Go to Company Settings
                </Link>
              </LBButton>
            </Grid>
          )}
        </Grid>
      </Banner>
    </Box>
  );
}

export default AllContributorsBanner;
